<template>
  <div id="pageTable">
    <v-layout row wrap>
      <v-flex xs12 sm12 md10 lg8 xl8 offset-md1 offset-lg2 offset-xl2>
        <v-card class="chat-room">
          <v-card-title primary-title>
            <h3>{{device.deviceType}} - {{device.imei}} {{device.plate != 'null' ? `(${device.plate})` : ''}}</h3>
          </v-card-title>
          <v-tabs v-model="active" fixed-tabs slider-color="primary">
            <v-tab ripple>Gửi lệnh</v-tab>
            <v-tab ripple>Gói tin ({{packets.length}})</v-tab>
            <v-tab-item>
              <v-card flat>
                <vue-perfect-scrollbar class="commands--scrollbar grey lighten-5">
                  <v-card-text class="chat-room--list pa-3">
                    <p
                      v-for="(item, index) in commandParsed"
                      :key="index"
                      :class="`${item.color}--text`"
                    >{{dateTimeUtil.formatSecondToGPSTime(item.time)}}: {{item.command}}</p>
                  </v-card-text>
                </vue-perfect-scrollbar>
                <v-card-actions>
                  <v-layout row wrap>
                    <v-flex sm12 md12>
                      <v-btn
                        @click="sendCommandSubmit(`STATUS#`)"
                        outline
                        round
                        color="primary"
                        dark
                        class="mb-2"
                      >STATUS#</v-btn>
                      <v-btn
                        @click="sendCommandSubmit(`CHECK#`)"
                        outline
                        round
                        color="primary"
                        dark
                        class="mb-2"
                      >CHECK#</v-btn>
                      <v-btn
                        @click="sendCommandSubmit(`WHERE#`)"
                        outline
                        round
                        color="primary"
                        dark
                        class="mb-2"
                      >WHERE#</v-btn>
                      <v-btn
                        @click="sendCommandSubmit(`URL#`)"
                        outline
                        round
                        color="primary"
                        dark
                        class="mb-2"
                      >URL#</v-btn>
                      <v-btn
                        @click="sendCommandSubmit(`RESET#`)"
                        outline
                        round
                        color="primary"
                        dark
                        class="mb-2"
                      >RESET#</v-btn>
                      <v-btn
                        @click="onUpdateLastWaypoint()"
                        outline
                        round
                        color="primary"
                        dark
                        class="mb-2"
                        v-if="!device.deviceType || device.deviceType !== 'MT20P'"
                      >UPDATE LAST WAYPOINT</v-btn>
                      <v-btn
                        @click="sendCommandSubmit(`RELAY,0#`)"
                        outline
                        round
                        color="success"
                        dark
                        class="mb-2"
                        v-if="!device.deviceType || device.deviceType === 'MT20'"
                      >RELAY,0#</v-btn>
                      <v-btn
                        @click="sendCommandSubmit(`RELAY,1#`)"
                        outline
                        round
                        color="red"
                        dark
                        class="mb-2"
                        v-if="!device.deviceType || device.deviceType === 'MT20'"
                      >RELAY,1#</v-btn>
                    </v-flex>
                    <v-flex sm12 md12>
                      <v-text-field
                        full-width
                        flat
                        clearable
                        solo
                        append-icon="send"
                        label="Nhập lệnh vào đây, Enter để gửi"
                        class="input-text"
                        @keyup.enter="sendCommandSubmit(text)"
                        v-model="text"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <vue-perfect-scrollbar class="packets--scrollbar grey lighten-5">
                  <v-card-text class="chat-room--list pa-3">
                    <p v-for="(item, index) in packetsParsed" :key="index">
                      {{dateTimeUtil.formatSecondToGPSTime(item.time)}}:
                      <v-chip small :color="item.color" class="white--text">{{item.description}}</v-chip>
                      {{item.data}}
                    </p>
                  </v-card-text>
                </vue-perfect-scrollbar>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import validate from '@/utils/validate';
import * as DateTimeUtil from '@/utils/datetime';

export default {
  components: { VuePerfectScrollbar },

  data () {
    return {
      device: null,
      active: 0,
      commands: [],
      packets: [],
      dateTimeUtil: DateTimeUtil,
      interval: null,
      utcTicks: 0,
      text: ''
    };
  },

  computed: {
    packetsParsed () {
      let items = [];
      this.packets.map(a => {
        let item = {
          data: a.data,
          description: this.getDescription(a.data),
          color: this.getDescriptionColor(a.data),
          time: a.time
        };
        items.push(item);
        return 0;
      });
      return items;
    },

    commandParsed () {
      let items = [];
      this.commands.map(a => {
        let item = {
          time: a.time,
          command: a.command,
          color: a.command.includes(`#`) ? `primary` : `black`
        };
        items.push(item);
        return 0;
      });
      return items;
    }
  },

  created () {
    this.device = {
      id: this.$route.query.deviceId,
      deviceType: this.$route.query.deviceType,
      imei: this.$route.query.imei,
      simPhone: this.$route.query.simPhone,
      plate: this.$route.query.plate
    };

    this.getCommand({ deviceId: this.device.id }).then(res => {
      this.commands = res;
      this.sortCommandByTime();
    });

    this.getPackets({ deviceId: this.device.id, utcTicks: this.utcTicks }).then(
      res => {
        this.packets = res;
        this.sortPacketByTime();
      }
    );

    if (!this.interval) {
      this.interval = setInterval(() => {
        this.getCommand({ deviceId: this.device.id }).then(res => {
          this.commands = res;
          this.sortCommandByTime();
        });
        this.getPackets({
          deviceId: this.device.id,
          utcTicks: this.utcTicks
        }).then(res => {
          res.map(a => {
            if (a.ticks > this.utcTicks) {
              this.utcTicks = a.ticks;
            }
            return 0;
          });
          if (res.length > 0) {
            this.packets.push(...res);
            this.sortPacketByTime();
          }
        });
      }, 5000);
    }
  },

  destroyed () {
    clearInterval(this.interval);
  },

  methods: {
    ...mapActions(['getCommand', 'getPackets', 'sendCommand', 'updateLastWaypoint']),
    sendCommandSubmit (command) {
      if (command) {
        this.sendCommand({
          deviceId: this.device.id,
          command: command
        })
          .then(_ => {
            window.getApp.showMessage('Gửi lệnh thành công');
            this.text = '';
          })
          .catch(_ => {
            window.getApp.showMessage('Gửi lệnh thất bại', 'error');
            this.text = '';
          });
      }
    },
    sortCommandByTime () {
      this.commands.sort((a, b) => b.time - a.time);
    },
    sortPacketByTime () {
      this.packets.sort((a, b) => b.time - a.time);
    },
    getDescription (data) {
      let result = '';
      let arr = data.split('-');
      switch (arr[3]) {
        case '01':
        case '13':
          result = 'Kết nối';
          break;
        case '22':
          result = 'Vị trí';
          break;
        case '26':
          result = 'Cảnh báo';
          break;
        default:
          result = 'Chưa xác định';
          break;
      }
      return result;
    },
    getDescriptionColor (data) {
      let result = '';
      let arr = data.split('-');
      switch (arr[3]) {
        case '01':
        case '13':
          result = 'success';
          break;
        case '22':
          result = 'blue';
          break;
        case '26':
          result = 'orange';
          break;
        default:
          result = 'grey';
          break;
      }
      return result;
    },

    async onUpdateLastWaypoint () {
      let res = await this.updateLastWaypoint({ deviceId: this.device.id }).catch(_ => {
        return false;
      });

      if (!res) {
        window.getApp.showMessage('Gửi lệnh thất bại', 'error');
        return;
      }

      window.getApp.showMessage('Gửi lệnh thành công');
    }
  }
};
</script>
<style scoped>
.commands--scrollbar {
  height: calc(100vh - 318px);
  overflow: auto;
}
.packets--scrollbar {
  height: calc(100vh - 190px);
  overflow: auto;
}
.small-icon {
  font-size: 14pt;
  padding-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/monitor/index.vue